import React from 'react';
import { styled } from 'styled-components';
import Heading from '../../../Heading';
import Flex from '../../../layout/Flex';
import Socials from '../../../Socials';
import Text from '../../../Text';

const BlogSocialsFlex = styled(Flex)`
  border-bottom: 1px solid var(--color-iron-300);
  border-top: 1px solid var(--color-iron-300);
  padding-bottom: var(--baseline);
  padding-top: var(--baseline);
`;

export default function BlogSocials() {
  return (
    <BlogSocialsFlex $direction={{ sm: 'column', lg: 'row' }} $justify={{ lg: 'space-between' }} $align={{ lg: 'center' }} $rowGap="baseline-sm">
      <div>
        <Heading as="h2"><Text en="Stay up-to-date" /></Heading>
        <p><Text en="Stay up-to-date with our work and blog posts?" /></p>
      </div>
      <Socials />
    </BlogSocialsFlex>
  );
}
